module.exports = __webpack_public_path__ + "img/download.6dc791a0.svg";